import React, { useState, useEffect } from "react";
import CourseHeader from "../../../Components/CourseHeader";
import { icons } from "../../../Assests/icons-imports/icons";
import CommonDataTable from "../../../Components/CommonDataTable";
import { Button } from "antd";
import { Helmet } from "react-helmet-async";
import useGetApi from "../../../services/useGetApi";
import IconButton from "../../../Components/IconButton";
import { DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";

const ManageStudent = () => {
  const [isLoading, error, userData, getData] = useGetApi(
    `users?role=student`,
    [],
    true
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getData(`users?role=student`);
  }, []);

  const handleEdit = () => {
    console.log("edit");
  };
  const handleDelete = () => {
    console.log("handleDelete");
  };
  const handleView = () => {
    console.log("handleView");
  };

  const columns = [
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <IconButton
            icon={EditOutlined}
            onClick={handleEdit}
            style={{ color: "blue" }}
          />
          <IconButton
            icon={DeleteOutlined}
            onClick={handleDelete}
            style={{ color: "red" }}
          />
          <IconButton
            icon={EyeOutlined}
            onClick={handleView}
            style={{ color: "green" }}
          />
        </div>
      ),
    },
  ];

  return (
    <div>
      <Helmet>
        <title>Manage Students | LMS-admin</title>
      </Helmet>
      <div className="d-flex gap-3 px-3">
        <div className="mt-5 pt-5 d-flex flex-column gap-4 w-100">
          <CourseHeader
            header={"Student"}
            btnName={"Add student"}
            icon={icons.apple_icon}
            redirectTo={"/add-student"}
          />
          <div className="p-3 bg-white">
            <CommonDataTable
              columns={columns}
              dataSource={userData}
              loading={loading}
              tableTitle={"Student"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageStudent;
